import { render } from "./HelloWorld.vue?vue&type=template&id=97cd47cc&scoped=true"
const script = {}

import "./HelloWorld.vue?vue&type=style&index=0&id=97cd47cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97cd47cc"]])

export default __exports__